import { createFileRoute } from "@tanstack/react-router";

import { publicBookingSearchSchema } from "@/modules/coaching/public-booking/schemas/publicBookingSearchSchema";
import { PublicBookingScreen } from "@/modules/coaching/public-booking/screens/PublicBookingScreen";

function PublicBookingRoute() {
  const { coachSlug, bookingCode } = Route.useParams();
  const { coachId, coachName, email, name } = Route.useSearch();

  const placeholderData =
    coachId !== undefined && coachName !== undefined
      ? { coachId, coachName }
      : undefined;

  return (
    <PublicBookingScreen
      coachSlug={coachSlug}
      bookingCode={bookingCode}
      placeholderData={placeholderData}
      memberName={name}
      memberEmail={email}
    />
  );
}

export const Route = createFileRoute(
  "/$coachSlug/coaching-session/$bookingCode/",
)({
  validateSearch: publicBookingSearchSchema,
  component: PublicBookingRoute,
});
